export class DragModel<T extends Object> {
  //Переносимая информация
  Data?: T;
  //Разрешить перетаскивание
  AllowDrag: boolean = false;
  //Разрешить дроп
  AllowDrop: boolean = false;
  //Перетаскивается ли сейчас элемент
  IsDragging: boolean = false;
  constructor(obj?: Partial<DragModel<T>>) {
    if (obj) {
      Object.assign(this, obj);
      this.IsDragging = false;
    }
  }
}
